import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { px2rem } from '../helpers/rem.mjs';

var SpacerBase = styled.div.withConfig({
  displayName: "SpacerBase",
  componentId: "sc-o9fzd7-0"
})(["", ""], function (props) {
  switch (props.type) {
    case "horizontal":
      return css(["height:", ";"], px2rem(props.value));
    case "vertical":
      return css(["width:", ";"], px2rem(props.value));
  }
});
var Spacer = function Spacer(props) {
  return jsx(SpacerBase, Object.assign({}, props, {
    type: "horizontal"
  }));
};
var SpacerVertical = function SpacerVertical(props) {
  return jsx(SpacerBase, Object.assign({}, props, {
    type: "vertical"
  }));
};

export { Spacer, SpacerVertical };
